<ul id="detail-bildungsanbieter-list" class="p-0">
  <li class="d-flex flex-column mb-2">
    <span id="detail-anbieter-name_label" class="fw-bold">Name</span>
    <span id="detail-anbieter-name">
      {{ anbieter.name }}
    </span>
  </li>

  <li class="d-flex flex-column mb-2">
    <span id="detail-anbieter-strasse_label" class="fw-bold">Adresse</span>
    <span id="detail-anbieter-strasse">
      <address class="address">
        {{ anbieter.adresse!.strasse }} <br />{{ anbieter.adresse!.plz }}
        {{ anbieter.adresse!.ort }} <br />
      </address>
    </span>
  </li>

  @if (anbieter?.telefon) {
    <li class="d-flex flex-column mb-2">
      <span id="detail-anbieter-telefon_label" class="fw-bold">Telefon</span>
      <span id="detail-anbieter-telefon">
        <a
          [nowWbsucheLibFocusableIfVisible]="collapsed"
          [attr.href]="telefonnummerHref"
          class="now-link-secondary now-link-icon now-icon-phone py-0"
          >{{ telefonnummer }}</a
        >
      </span>
    </li>
  }

  @if (anbieter?.mobil) {
    <li class="d-flex flex-column mb-2">
      <span id="detail-anbieter-mobil_label" class="fw-bold">Mobil-Telefon</span>
      <span id="detail-anbieter-mobil">
        <a
          [nowWbsucheLibFocusableIfVisible]="collapsed"
          [attr.href]="mobilnummerHref"
          class="now-link-secondary now-link-icon now-icon-phone py-0"
          >{{ mobilnummer }}</a
        >
      </span>
    </li>
  }

  @if (anbieter?.faxVorwahl && anbieter?.faxDurchwahl) {
    <li class="d-flex flex-column mb-2">
      <span id="detail-anbieter-fax_label" class="fw-bold">Fax</span>
      <span id="detail-anbieter-fax">
        <a
          [nowWbsucheLibFocusableIfVisible]="collapsed"
          [attr.href]="faxnummerHref"
          class="now-link-secondary now-link-icon now-icon-envelope py-0"
          >{{ faxnummer }}</a
        >
      </span>
    </li>
  }

  <li class="d-flex flex-column mb-2">
    <span id="detail-anbieter-email_label" class="fw-bold">E-Mail</span>
    <span id="detail-anbieter-email">
      <a
        [nowWbsucheLibFocusableIfVisible]="collapsed"
        [attr.href]="'mailto:' + anbieter.email"
        class="now-link-secondary now-link-icon now-icon-envelope py-0"
      >
        {{ anbieter.email }}</a
      >
    </span>
  </li>

  <li class="d-flex flex-column">
    <span id="detail-anbieter-homepage_label" class="fw-bold">Internet</span>
    <span id="detail-anbieter-homepage">
      <a
        [nowWbsucheLibFocusableIfVisible]="collapsed"
        [href]="anbieter.homepage"
        title="Link zur Webseite des Anbieters"
        rel="noreferrer"
        target="_blank"
        class="now-link-secondary now-link-icon now-icon-arrow-square-out py-0 d-print-inline text-wrap"
      >
        {{ anbieter.homepage }}
      </a>
    </span>
  </li>
</ul>
